import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { DevCenterClient } from './dev-center-client.js';

export function useDevCenterClient({
  siteId,
}: { siteId?: string } = {}): DevCenterClient {
  const httpClient = useHttpClient({ type: 'backoffice', siteId });
  const client = useMemo(() => new DevCenterClient(httpClient), [httpClient]);

  return usePanoramaMethodLogger(client);
}
